export default "__VITE_PUBLIC_ASSET__c224c91d__"